import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';
import { GruppoStudioDTO } from '../../../model/newModel';
import { GroupService } from './group.service';

@Component({
  selector: 'app-group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.css'],
})
export class GroupComponent
  extends AbstractBaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  gruppo: GruppoStudioDTO;

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  constructor(
    private route: ActivatedRoute,
    private groupService: GroupService,
    private spinner: NgxSpinnerService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.route.queryParams.subscribe((params) => {
      this.spinner.show();
      this.groupService.getGruppo(params.idGruppo).subscribe(
        (result) => {
          this.gruppo = result;
          this.spinner.hide();
        },
        (error) => {
          this.spinner.hide();
          console.log('Errore getGruppo');
        }
      );
    });
  }
}
